/**
 * Registering the service worker, and the two places it must not be.
 *
 * NOT ON `file://`. The standalone build is one HTML file opened from a memory stick on draft
 * night; `navigator.serviceWorker.register` throws there, and a worker would be pointless anyway
 * because everything is already in the file.
 *
 * NOT IN DEV. A worker caching a dev server's output is how you spend an afternoon wondering why
 * an edit did nothing.
 *
 * The worker itself is generated at build time from what the build produced — see
 * `build/make-sw.mjs`, which is also where the caching rules and the reasoning live.
 */

export function registerServiceWorker(): void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  if (!/^https?:$/.test(window.location.protocol)) return;
  if (import.meta.env?.DEV) return;

  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').then((reg) => {
      /*
       * Check for a new build when the app is brought back to the foreground. A home-screen app
       * is rarely reloaded — somebody could sit on a stale build for a week — and the check is a
       * conditional GET of one small file.
       */
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') void reg.update();
      });
    }).catch(() => {
      /* A worker that will not register is not a reason to fail the app. It is an optimisation:
         without it everything still works, it just needs the network. */
    });
  });
}
